module.exports = __webpack_public_path__ + "aa5b6f4f3968c7d9af3149845f393480.svg";